import { IGizmoCallbacks } from '../../types';
import Gizmo from '../gizmo';

interface IParams {
  context: {
    gizmo: Gizmo;
    callbacks: IGizmoCallbacks;
  };
}

/**
 * Call the server script of the gizmo's dao
 */
async function serverScript({ context }: IParams) {
  const { gizmo, callbacks } = context;
  const dao = gizmo.getDao();
  const rootGizmoData = callbacks.getInfoCB({
    type: 'rootGizmoData',
  });

  if (dao) {
    await dao.serverScript({
      gizmo,
      rootGizmoData,
    });
  }
}

export default serverScript;
